{
	"units": {
        "header": "Overzicht",
        "details": "Handelaar Details",
        "days": "in dagen",
        "configEKPriceChangeDays": "Periode EG-wijzigingen",
        "configProductCreationDays": "Periode Markering nieuwe artikelen",
        "enabled": "Actief",
        "disabled": "Deaktiviert",
        "editSuccess": "Händler {{unitName}} wurde erfolgreich aktualisiert.",
        "buttons": {
            "edit": "Veranderen",
            "cancel": "Afbreken",
            "save": "Opslaan"
        }
    },
    "unitsBreadcrumbs": {
        "list": "Overzicht"
    }
}
